import { render } from "./MobileAccordion.vue?vue&type=template&id=29a6ffaf"
import script from "./MobileAccordion.vue?vue&type=script&lang=js"
export * from "./MobileAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__